import React from 'react';
import { motion } from 'framer-motion';
import PropTypes from 'prop-types';
import HeaderVariant from '../common/HeaderVariant';
import Footer from '../Footer/Footer';

const LegalPageLayout = ({ title, content }) => {
  return (
    <div className="min-h-screen bg-black">
      <HeaderVariant />
      
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-4xl mx-auto px-4 py-24"
      >
        <h1 className="text-4xl md:text-5xl font-bold text-white mb-12 border-b border-gray-800 pb-6">
          {title}
        </h1>
        
        <div className="prose prose-invert prose-lg max-w-none">
          {content.sections.map((section, index) => (
            <motion.section 
              key={index} 
              className="mb-12"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
            >
              {section.title && (
                <h2 className="text-2xl font-semibold text-white mb-4 flex items-center">
                  <span className="mr-4 text-gray-500">{section.title.split('.')[0]}.</span>
                  <span>{section.title.split('.')[1]}</span>
                </h2>
              )}
              <div 
                className="text-gray-300 text-justify leading-relaxed space-y-4 whitespace-pre-wrap pl-0 md:pl-8"
                style={{ fontSize: '15px' }}
              >
                {section.content}
              </div>
            </motion.section>
          ))}
        </div>
      </motion.div>

      <Footer />
    </div>
  );
};

LegalPageLayout.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.shape({
    lastUpdated: PropTypes.string,
    sections: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        content: PropTypes.string.isRequired
      })
    ).isRequired
  }).isRequired
};

export default LegalPageLayout; 